import { routes } from '@redwoodjs/router'

const PACKNING_BASE = '/packning'
const ADMIN_PACKNING_BASE = '/admin/packning'
const INTERNAL_ORIGIN = 'https://lagshoppen.local'

const isPackningPathAllowed = (pathname: string) =>
  pathname === PACKNING_BASE ||
  pathname.startsWith(`${PACKNING_BASE}/`) ||
  pathname === ADMIN_PACKNING_BASE ||
  pathname.startsWith(`${ADMIN_PACKNING_BASE}/`)

const isPackningPathForRole = (pathname: string, role?: string) => {
  if (pathname === ADMIN_PACKNING_BASE || pathname.startsWith(`${ADMIN_PACKNING_BASE}/`)) {
    return role === 'admin'
  }
  if (pathname === PACKNING_BASE || pathname.startsWith(`${PACKNING_BASE}/`)) {
    return role === 'lead' || role === 'member'
  }
  return false
}

export const buildLoginWithReturnTo = (pathname: string, search = '') => {
  const returnTo = `${pathname}${search}`
  return `${routes.login()}?returnTo=${encodeURIComponent(returnTo)}`
}

export const getValidatedPackningReturnTo = (rawReturnTo?: string | null) => {
  if (!rawReturnTo || !rawReturnTo.startsWith('/') || rawReturnTo.startsWith('//')) {
    return null
  }

  try {
    const parsed = new URL(rawReturnTo, INTERNAL_ORIGIN)
    if (parsed.origin !== INTERNAL_ORIGIN || !isPackningPathAllowed(parsed.pathname)) {
      return null
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}

export const getValidatedPackningReturnToFromSearch = (search: string) => {
  const params = new URLSearchParams(search)
  return getValidatedPackningReturnTo(params.get('returnTo'))
}

export const canRoleUsePackningReturnTo = (
  role: string | undefined,
  returnTo: string
) => {
  try {
    const parsed = new URL(returnTo, INTERNAL_ORIGIN)
    return isPackningPathForRole(parsed.pathname, role)
  } catch {
    return false
  }
}
